import { get } from "svelte/store";
import { navigateToWorkflow } from "./navigateToWorkflow";

// Adds a "Go to Parent" item per script that references the currently open
// workflow as a subworkflow, regardless of what (if anything) was
// right-clicked. `workflowParentsStore` holds a list of `{ id, name }`.
export function createWorkflowParentContextMenuExtension(filetreeStore, workflowParentsStore) {
  return {
    createItemsProvider() {
      return {
        getItems(_step, _sequence) {
          const parents = get(workflowParentsStore) || [];

          return parents.map((parent, index) => ({
            label: parents.length > 1 ? `Go to Parent: ${parent.name}` : "Go to Parent",
            order: 15 + index,
            callback: () => navigateToWorkflow(filetreeStore, parent.id),
          }));
        },
      };
    },
  };
}
